// src/routes/appRoutes.jsx
import React from "react";
import LoginPage from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import HomeRedirect from "../pages/HomeRedirect";

// Usuários
import UsuariosPage from "../pages/cadastros/Usuarios/UsuariosPage";
import NovoUsuarioPage from "../pages/NovoUsuarioPage";
import NovoUsuario from "../pages/cadastros/Usuarios/NovoUsuario";
import EditarUsuario from "../pages/cadastros/Usuarios/EditarUsuario";

// Empresas
import EmpresasPage from "../pages/cadastros/Empresas/EmpresasPage";
import NovaEmpresa from "../pages/cadastros/Empresas/NovaEmpresa";
import EditarEmpresa from "../pages/cadastros/Empresas/EditarEmpresa";

// Setores
import SetoresPage from "../pages/cadastros/Setores/SetoresPage";
import NovoSetor from "../pages/cadastros/Setores/NovoSetor";
import EditarSetor from "../pages/cadastros/Setores/EditarSetor";

// Máquinas
import MaquinasPage from "../pages/cadastros/Maquinas/MaquinasPage";
import NovaMaquina from "../pages/cadastros/Maquinas/NovaMaquina";
import EditarMaquina from "../pages/cadastros/Maquinas/EditarMaquina";


// Fornecedores
import FornecedoresPage from "../pages/cadastros/Fornecedores/FornecedoresPage";
import NovoFornecedor from "../pages/cadastros/Fornecedores/NovoFornecedor";
import EditarFornecedor from "../pages/cadastros/Fornecedores/EditarFornecedor";


// Prestadores de Serviço
import PrestadoresPage from "../pages/cadastros/Prestadores/PrestadoresPage";
import NovoPrestador from "../pages/cadastros/Prestadores/NovoPrestador";
import EditarPrestador from "../pages/cadastros/Prestadores/EditarPrestador";
// Cooperadores (Manutenção)
import CooperadoresPage from "../pages/cadastros/Cooperadores/CooperadoresPage";
import NovoCooperador from "../pages/cadastros/Cooperadores/NovoCooperador";
import EditarCooperador from "../pages/cadastros/Cooperadores/EditarCooperador";



// Peças
import PecasPage from "../pages/cadastros/pecas/PecasPage";
import NovaPeca from "../pages/cadastros/pecas/NovaPeca";
import EditarPeca from "../pages/cadastros/pecas/EditarPeca";

// Procedimentos
import ProcedimentosPage from "../pages/cadastros/Procedimentos/ProcedimentosPage";
import NovoProcedimento from "../pages/cadastros/Procedimentos/NovoProcedimento";
import EditarProcedimento from "../pages/cadastros/Procedimentos/EditarProcedimento";

// Preventivas
import PreventivasPage from "../pages/cadastros/Preventivas/PreventivasPage";
import NovaPreventiva from "../pages/cadastros/Preventivas/NovoPreventiva";
import EditarPreventiva from "../pages/cadastros/Preventivas/EditarPreventiva";

// Checklists
import ChecklistsPage from "../pages/cadastros/Checklists/ChecklistsPage";
import NovoChecklist from "../pages/cadastros/Checklists/NovoChecklist";
import EditarChecklist from "../pages/cadastros/Checklists/EditarChecklist";
import ChecklistExecutarOsPage from "../pages/checklists/ChecklistExecutarOsPage";
import ChecklistExecutarPage from "../pages/checklists/ChecklistExecutarPage";
import ChecklistsAbertosPage from "../pages/checklists/ChecklistsAbertosPage";
import ChecklistsFinalizadosPage from "../pages/checklists/ChecklistsFinalizadosPage";
import CalendarioChecklistsPage from "../pages/checklists/CalendarioChecklistsPage";


// Status
import StatusPage from "../pages/cadastros/Status/StatusPage";
import NovoStatus from "../pages/cadastros/Status/NovoStatus";
import EditarStatus from "../pages/cadastros/Status/EditarStatus";

// Defeitos
import DefeitosPage from "../pages/cadastros/Defeitos/DefeitosPage";
import NovoDefeito from "../pages/cadastros/Defeitos/NovoDefeito";
import EditarDefeito from "../pages/cadastros/Defeitos/EditarDefeito";
import DefeitosPorMaquina from "../pages/cadastros/Defeitos/DefeitosPorMaquina";

// Ordens de Serviço
import OrdensServicoPage from "../pages/ordens-servico/OrdensServicoPage";
import NovaOSWrapper from "../pages/ordens-servico/NovaOSWrapper";
import KioskLanding from "../pages/ordens-servico/KioskLanding";
import EditarOS from "../pages/ordens-servico/EditarOS";
import OrdensServicoExecucao from "../pages/ordens-servico/OrdensServicoExecucao";
import AtendimentoForm from "../pages/ordens-servico/AtendimentoForm";

// Gerenciar OS
import TabelaOSPage from "../pages/gerenciar/TabelaOSPage";
import TabelaAtendimentosPage from "../pages/gerenciar/TabelaAtendimentosPage";
import ImportarExportarDados from "../pages/gerenciar/ImportarExportarDados";
import MeusAtendimentos from "../pages/gerenciar/MeusAtendimentos";
import OpcoesPage from "../pages/gerenciar/OpcoesPage";

// Gerenciar
import MudarEmpresa from "../pages/gerenciar/MudarEmpresa";

// Preventivas – módulo de execução
import PreventivasAbertasPage from "../pages/preventivas/PreventivasAbertasPage";
import PreventivasFinalizadasPage from "../pages/preventivas/PreventivasFinalizadasPage";
import CalendarioPreventivasPage from "../pages/preventivas/CalendarioPreventivasPage";
import CalendarioAgendamentosPage from "../pages/planejamento/CalendarioAgendamentosPage";
import PreventivaExecutarPage from "../pages/preventivas/PreventivaExecutarPage";

// Planejamento – Agendamento de Técnicos
import AgendamentosTecnicosPage from "../pages/planejamento/AgendamentosTecnicosPage";
import AtendimentosVisitasPage from "../pages/planejamento/AtendimentosVisitasPage";
import NovaVisitaPage from "../pages/planejamento/NovaVisitaPage";



// Financeiro (novo módulo)
import FinanceiroHomePage from "../pages/financeiro/FinanceiroHomePage";
import FinanceiroContasPage from "../pages/financeiro/FinanceiroContasPage";
import FinanceiroLancamentosPage from "../pages/financeiro/FinanceiroLancamentosPage";
import FinanceiroCartoesCreditoPage from "../pages/financeiro/FinanceiroCartoesCreditoPage";
import FinanceiroCartoesCreditoFormPage from "../pages/financeiro/FinanceiroCartoesCreditoFormPage";
import FinanceiroContasPagarPage from "../pages/financeiro/FinanceiroContasPagarPage";
import FinanceiroContasPagarFormPage from "../pages/financeiro/FinanceiroContasPagarFormPage";
import FinanceiroReceitasPage from "../pages/financeiro/FinanceiroReceitasPage";
import FinanceiroReceitasFormPage from "../pages/financeiro/FinanceiroReceitasFormPage";
import FinanceiroContratosPage from "../pages/financeiro/FinanceiroContratosPage";
import FinanceiroContratoFormPage from "../pages/financeiro/FinanceiroContratoFormPage";
import FinanceiroInstalacoesPage from "../pages/financeiro/FinanceiroInstalacoesPage";
import FinanceiroInstalacaoFormPage from "../pages/financeiro/FinanceiroInstalacaoFormPage";
import FinanceiroPreventivasPage from "../pages/financeiro/FinanceiroPreventivasPage";
import FinanceiroPreventivaFormPage from "../pages/financeiro/FinanceiroPreventivaFormPage";
import FinanceiroOrdensServicoPage from "../pages/financeiro/FinanceiroOrdensServicoPage";
import FinanceiroOrdemServicoFormPage from "../pages/financeiro/FinanceiroOrdemServicoFormPage";
import FinanceiroGerenciarPropostasPage from "../pages/financeiro/FinanceiroGerenciarPropostasPage";
import FinanceiroFluxoCaixaPage from "../pages/financeiro/FinanceiroFluxoCaixaPage";
import FinanceiroRelatoriosPage from "../pages/financeiro/FinanceiroRelatoriosPage";
import FinanceiroValoresServicosPage from "../pages/financeiro/FinanceiroValoresServicosPage";

// Estoque
import PedidosMaterialPage from "../pages/estoque/PedidosMaterialPage";
import EstoqueInternoPage from "../pages/estoque/EstoqueInternoPage";
import HistoricoPedidosPage from "../pages/estoque/HistoricoPedidosPage";

// KPIs
import KpiMtbfPage from "../pages/kpis/KpiMtbfPage";
import KpiMttrPage from "../pages/kpis/KpiMttrPage";
import KpiTecnicosPage from "../pages/kpis/KpiTecnicosPage";
import KpiCustoManutencaoPage from "../pages/kpis/KpiCustoManutencaoPage";
import KpiOutrosPage from "../pages/kpis/KpiOutrosPage";

// Rotas que NÃO exigem login
export const publicRoutes = [
  { path: "/login", element: <LoginPage /> },
  { path: "/cadastro-novo-usuario", element: <NovoUsuarioPage /> },
];

// Rotas que exigem usuário logado (PrivateRoute em App.jsx)
export const privateRoutes = [
  { path: "/", element: <HomeRedirect /> },
  { path: "/dashboard", element: <DashboardPage /> },

  // Usuários
  { path: "/cadastros/usuarios", element: <UsuariosPage />, perm: { modulo: "cadastros", recurso: "usuarios", acao: "tabela" } },
  { path: "/cadastros/usuarios/novo", element: <NovoUsuario />, perm: { modulo: "cadastros", recurso: "usuarios", acao: "form" } },
  { path: "/cadastros/usuarios/editar/:id", element: <EditarUsuario />, perm: { modulo: "cadastros", recurso: "usuarios", acao: "altera" } },

  // Empresas
  { path: "/cadastros/empresas", element: <EmpresasPage />, perm: { modulo: "cadastros", recurso: "empresas", acao: "tabela" } },
  { path: "/cadastros/empresas/novo", element: <NovaEmpresa />, perm: { modulo: "cadastros", recurso: "empresas", acao: "form" } },
  { path: "/cadastros/empresas/editar/:id", element: <EditarEmpresa />, perm: { modulo: "cadastros", recurso: "empresas", acao: "altera" } },
  { path: "/cadastros/clientes", element: <EmpresasPage />, perm: { modulo: "cadastros", recurso: "empresas", acao: "tabela" } },
  { path: "/cadastros/clientes/novo", element: <NovaEmpresa />, perm: { modulo: "cadastros", recurso: "empresas", acao: "form" } },
  { path: "/cadastros/clientes/editar/:id", element: <EditarEmpresa />, perm: { modulo: "cadastros", recurso: "empresas", acao: "altera" } },

  // Setores
  { path: "/cadastros/setores", element: <SetoresPage />, perm: { modulo: "cadastros", recurso: "setores", acao: "tabela" } },
  { path: "/cadastros/setores/novo", element: <NovoSetor />, perm: { modulo: "cadastros", recurso: "setores", acao: "form" } },
  { path: "/cadastros/setores/editar/:id", element: <EditarSetor />, perm: { modulo: "cadastros", recurso: "setores", acao: "altera" } },

  // Equipamentos (Fitness) — alias de Máquinas
  { path: "/cadastros/equipamentos", element: <MaquinasPage />, perm: { modulo: "cadastros", recurso: "maquinas", acao: "tabela" } },
  { path: "/cadastros/equipamentos/novo", element: <NovaMaquina />, perm: { modulo: "cadastros", recurso: "maquinas", acao: "form" } },
  { path: "/cadastros/equipamentos/editar/:id", element: <EditarMaquina />, perm: { modulo: "cadastros", recurso: "maquinas", acao: "altera" } },

  // Máquinas (legado)
  { path: "/cadastros/maquinas", element: <MaquinasPage />, perm: { modulo: "cadastros", recurso: "maquinas", acao: "tabela" } },
  { path: "/cadastros/maquinas/novo", element: <NovaMaquina />, perm: { modulo: "cadastros", recurso: "maquinas", acao: "form" } },
  { path: "/cadastros/maquinas/editar/:id", element: <EditarMaquina />, perm: { modulo: "cadastros", recurso: "maquinas", acao: "altera" } },




  // Fornecedores
  { path: "/cadastros/fornecedores", element: <FornecedoresPage />, perm: { modulo: "cadastros", recurso: "fornecedores", acao: "tabela" } },
  { path: "/cadastros/fornecedores/novo", element: <NovoFornecedor />, perm: { modulo: "cadastros", recurso: "fornecedores", acao: "form" } },
  { path: "/cadastros/fornecedores/editar/:id", element: <EditarFornecedor />, perm: { modulo: "cadastros", recurso: "fornecedores", acao: "altera" } },


// Prestadores de Serviço
{ path: "/cadastros/prestadores", element: <PrestadoresPage />, perm: { modulo: "cadastros", recurso: "prestadores", acao: "tabela" } },
{ path: "/cadastros/prestadores/novo", element: <NovoPrestador />, perm: { modulo: "cadastros", recurso: "prestadores", acao: "form" } },
{ path: "/cadastros/prestadores/editar/:id", element: <EditarPrestador />, perm: { modulo: "cadastros", recurso: "prestadores", acao: "altera" } },

  // Cooperadores (Manutenção)
  { path: "/cadastros/cooperadores", element: <CooperadoresPage />, perm: { modulo: "cadastros", recurso: "cooperadores", acao: "tabela" } },
  { path: "/cadastros/cooperadores/novo", element: <NovoCooperador />, perm: { modulo: "cadastros", recurso: "cooperadores", acao: "form" } },
  { path: "/cadastros/cooperadores/editar/:id", element: <EditarCooperador />, perm: { modulo: "cadastros", recurso: "cooperadores", acao: "altera" } },


  // Peças
  { path: "/cadastros/pecas", element: <PecasPage />, perm: { modulo: "cadastros", recurso: "pecas", acao: "tabela" } },
  { path: "/cadastros/pecas/novo", element: <NovaPeca />, perm: { modulo: "cadastros", recurso: "pecas", acao: "form" } },
  { path: "/cadastros/pecas/editar/:id", element: <EditarPeca />, perm: { modulo: "cadastros", recurso: "pecas", acao: "altera" } },

  // Procedimentos
  { path: "/cadastros/procedimentos", element: <ProcedimentosPage />, perm: { modulo: "cadastros", recurso: "procedimentos", acao: "tabela" } },
  { path: "/cadastros/procedimentos/novo", element: <NovoProcedimento />, perm: { modulo: "cadastros", recurso: "procedimentos", acao: "form" } },
  { path: "/cadastros/procedimentos/editar/:id", element: <EditarProcedimento />, perm: { modulo: "cadastros", recurso: "procedimentos", acao: "altera" } },

  // Status
  { path: "/cadastros/status", element: <StatusPage />, perm: { modulo: "cadastros", recurso: "status", acao: "tabela" } },
  { path: "/cadastros/status/novo", element: <NovoStatus />, perm: { modulo: "cadastros", recurso: "status", acao: "form" } },
  { path: "/cadastros/status/editar/:id", element: <EditarStatus />, perm: { modulo: "cadastros", recurso: "status", acao: "altera" } },

  // Defeitos
  { path: "/cadastros/defeitos", element: <DefeitosPage />, perm: { modulo: "cadastros", recurso: "defeitos", acao: "tabela" } },
  { path: "/cadastros/defeitos/novo", element: <NovoDefeito />, perm: { modulo: "cadastros", recurso: "defeitos", acao: "form" } },
  { path: "/cadastros/defeitos/editar/:id", element: <EditarDefeito />, perm: { modulo: "cadastros", recurso: "defeitos", acao: "altera" } },
  { path: "/cadastros/defeitos/por-maquina", element: <DefeitosPorMaquina />, perm: { modulo: "cadastros", recurso: "defeitos", acao: "tabela" } },

  // Preventivas
  { path: "/cadastros/preventivas", element: <PreventivasPage />, perm: { modulo: "cadastros", recurso: "preventivas", acao: "tabela" } },
  { path: "/cadastros/preventivas/novo", element: <NovaPreventiva />, perm: { modulo: "cadastros", recurso: "preventivas", acao: "form" } },
  { path: "/cadastros/preventivas/editar/:id", element: <EditarPreventiva />, perm: { modulo: "cadastros", recurso: "preventivas", acao: "altera" } },

  // Checklists
  { path: "/cadastros/checklists", element: <ChecklistsPage />, perm: { modulo: "cadastros", recurso: "checklists", acao: "tabela" } },
  { path: "/cadastros/checklists/novo", element: <NovoChecklist />, perm: { modulo: "cadastros", recurso: "checklists", acao: "form" } },
  { path: "/cadastros/checklists/editar/:id", element: <EditarChecklist />, perm: { modulo: "cadastros", recurso: "checklists", acao: "altera" } },

  // Ordens de Serviço
  { path: "/ordens-servico", element: <OrdensServicoExecucao />, perm: { modulo: "ordensServico", recurso: "porStatus", acao: "tabela" } },
  { path: "/ordens-servico/status", element: <OrdensServicoPage />, perm: { modulo: "ordensServico", recurso: "porStatus", acao: "tabela" } },
  { path: "/ordens-servico/kiosk", element: <KioskLanding />, perm: { modulo: "ordensServico", recurso: "abrirNovaOS", acao: "form" } },
  { path: "/ordens-servico/abrir-nova-os", element: <NovaOSWrapper />, perm: { modulo: "ordensServico", recurso: "abrirNovaOS", acao: "form" } },
  { path: "/ordens-servico/editar/:osId", element: <EditarOS />, perm: { modulo: "ordensServico", recurso: "editarOS", acao: "form" } },
  {
    path: "/ordens-servico/atendimento/:osId",
    element: <AtendimentoForm />,
    // 🔒 Somente Técnico+ pode iniciar/abrir atendimento
    perm: { modulo: "ordensServico", recurso: "meusAtendimentos", acao: "tabela" },
  },

  // Checklists – execução (ex.: instalação)
  {
    path: "/checklists/executar-os/:osId",
    element: <ChecklistExecutarOsPage />,
    perm: { modulo: "ordensServico", recurso: "meusAtendimentos", acao: "tabela" },
  },

  // Gerenciar
  // Troca de empresa/cliente é rota global: precisa funcionar mesmo quando o usuário
  // estiver com matriz de permissões custom (permissoesAtivas) sem essa regra.
  { path: "/gerenciar/mudar-empresa", element: <MudarEmpresa /> },
  { path: "/gerenciar/mudar-cliente", element: <MudarEmpresa /> },

  // Preventivas – módulo de execução
  { path: "/preventivas/abertas", element: <PreventivasAbertasPage />, perm: { modulo: "preventivas", recurso: "abertas", acao: "tabela" } },
  { path: "/preventivas/executar/:id", element: <PreventivaExecutarPage />, perm: { modulo: "preventivas", recurso: "execucao", acao: "iniciarExecucao" } },
  { path: "/preventivas/finalizadas", element: <PreventivasFinalizadasPage />, perm: { modulo: "preventivas", recurso: "finalizadas", acao: "tabela" } },
  { path: "/preventivas/calendario", element: <CalendarioPreventivasPage />, perm: { modulo: "preventivas", recurso: "calendario", acao: "tabela" } },

  // Checklists – módulo operacional
  { path: "/checklists/abertos", element: <ChecklistsAbertosPage />, perm: { modulo: "checklists", recurso: "abertas", acao: "tabela" } },
  { path: "/checklists/executar/:id", element: <ChecklistExecutarPage />, perm: { modulo: "checklists", recurso: "execucao", acao: "iniciarExecucao" } },
  { path: "/checklists/finalizados", element: <ChecklistsFinalizadosPage />, perm: { modulo: "checklists", recurso: "finalizadas", acao: "tabela" } },
  { path: "/checklists/calendario", element: <CalendarioChecklistsPage />, perm: { modulo: "checklists", recurso: "calendario", acao: "tabela" } },

  // Planejamento – Agendamento de Técnicos
  { path: "/planejamento/agendamentos-tecnicos", element: <AgendamentosTecnicosPage />, perm: { modulo: "planejamento", recurso: "agendamentos", acao: "tabela" } },
  { path: "/planejamento/calendario", element: <CalendarioAgendamentosPage />, perm: { modulo: "planejamento", recurso: "calendario", acao: "tabela" } },
  { path: "/planejamento/atendimentos-visitas", element: <AtendimentosVisitasPage />, perm: { modulo: "planejamento", recurso: "atendimentosVisitas", acao: "tabela" } },
  { path: "/planejamento/nova-visita", element: <NovaVisitaPage />, perm: { modulo: "planejamento", recurso: "atendimentosVisitas", acao: "tabela" } },

  { path: "/gerenciar/tabela-os", element: <TabelaOSPage />, perm: { modulo: "gerenciar", recurso: "tabelaOS", acao: "tabela" } },
  { path: "/gerenciar/tabela-atendimentos", element: <TabelaAtendimentosPage />, perm: { modulo: "gerenciar", recurso: "tabelaAtendimentos", acao: "tabela" } },
  { path: "/gerenciar/meus-atendimentos", element: <MeusAtendimentos />, perm: { modulo: "ordensServico", recurso: "meusAtendimentos", acao: "tabela" } },
  { path: "/gerenciar/importar-exportar", element: <ImportarExportarDados />, perm: { modulo: "gerenciar", recurso: "importarExportar", acao: "acessa" } },
  {
    path: "/gerenciar/opcoes",
    element: <OpcoesPage />,
    perm: { modulo: "gerenciar", recurso: "opcoes", acao: "acessa" },
  },

  // Estoque
  { path: "/estoque/pedidos-pecas", element: <PedidosMaterialPage />, perm: { modulo: "estoque", recurso: "pedidosMaterial", acao: "tabela" } },
  { path: "/estoque/pedidos-pecas/os/:osId", element: <PedidosMaterialPage />, perm: { modulo: "estoque", recurso: "pedidosMaterial", acao: "tabela" } },
  { path: "/estoque/estoque-interno", element: <EstoqueInternoPage />, perm: { modulo: "estoque", recurso: "estoqueInterno", acao: "tabela" } },
  { path: "/estoque/historico-pedidos", element: <HistoricoPedidosPage />, perm: { modulo: "estoque", recurso: "pedidosMaterial", acao: "tabela" } },

  // KPIs
  { path: "/kpis/mtbf", element: <KpiMtbfPage />, perm: { modulo: "kpis", recurso: "mtbf", acao: "tabela" } },
  { path: "/kpis/mttr", element: <KpiMttrPage />, perm: { modulo: "kpis", recurso: "mttr", acao: "tabela" } },
  { path: "/kpis/tecnicos", element: <KpiTecnicosPage />, perm: { modulo: "kpis", recurso: "tecnicos", acao: "tabela" } },
  { path: "/kpis/custo-manutencao", element: <KpiCustoManutencaoPage />, perm: { modulo: "kpis", recurso: "custoManutencao", acao: "tabela" } },
  { path: "/kpis/outros", element: <KpiOutrosPage />, perm: { modulo: "kpis", recurso: "outros", acao: "tabela" } },

  // =================== FINANCEIRO (área separada) ===================
  { path: "/financeiro", element: <FinanceiroHomePage />, area: "FINANCEIRO" },
  { path: "/financeiro/contas", element: <FinanceiroContasPage />, area: "FINANCEIRO" },
  { path: "/financeiro/lancamentos", element: <FinanceiroLancamentosPage />, area: "FINANCEIRO" },
  { path: "/financeiro/cartoes-credito", element: <FinanceiroCartoesCreditoPage />, area: "FINANCEIRO" },
  { path: "/financeiro/cartoes-credito/novo", element: <FinanceiroCartoesCreditoFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/cartoes-credito/editar/:id", element: <FinanceiroCartoesCreditoFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/contas-pagar", element: <FinanceiroContasPagarPage />, area: "FINANCEIRO" },
  { path: "/financeiro/contas-pagar/nova", element: <FinanceiroContasPagarFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/contas-pagar/editar/:id", element: <FinanceiroContasPagarFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/receitas", element: <FinanceiroReceitasPage />, area: "FINANCEIRO" },
  { path: "/financeiro/receitas/nova", element: <FinanceiroReceitasFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/receitas/editar/:id", element: <FinanceiroReceitasFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/contratos", element: <FinanceiroContratosPage />, area: "FINANCEIRO" },
  { path: "/financeiro/contratos/novo", element: <FinanceiroContratoFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/contratos/editar/:id", element: <FinanceiroContratoFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/cadastros/valores-servicos", element: <FinanceiroValoresServicosPage />, area: "FINANCEIRO" },
  { path: "/financeiro/instalacoes", element: <FinanceiroInstalacoesPage />, area: "FINANCEIRO" },
  { path: "/financeiro/instalacoes/nova", element: <FinanceiroInstalacaoFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/instalacoes/editar/:id", element: <FinanceiroInstalacaoFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/preventivas", element: <FinanceiroPreventivasPage />, area: "FINANCEIRO" },
  { path: "/financeiro/preventivas/nova", element: <FinanceiroPreventivaFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/preventivas/editar/:id", element: <FinanceiroPreventivaFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/propostas-os", element: <FinanceiroOrdensServicoPage />, area: "FINANCEIRO" },
  { path: "/financeiro/propostas-os/nova", element: <FinanceiroOrdemServicoFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/propostas-os/editar/:id", element: <FinanceiroOrdemServicoFormPage />, area: "FINANCEIRO" },
  { path: "/financeiro/gerenciar-propostas", element: <FinanceiroGerenciarPropostasPage />, area: "FINANCEIRO" },
  { path: "/financeiro/relatorios", element: <FinanceiroRelatoriosPage />, area: "FINANCEIRO" },
  { path: "/financeiro/fluxo-caixa", element: <FinanceiroFluxoCaixaPage />, area: "FINANCEIRO" },

];
